import React from 'react';
import './Logo.css';

const Logo = ({ size = 'md' }) => {
  return (
    <div className={`logo logo--${size}`}>
      <span className="logo__zila">Zila</span>
      <span className="logo__cab">Cab</span>
    </div>
  );
};

export default Logo;
